import Card from "../../../../components/Card";
import {useAdmin} from "../../../../contexts/AdminContext";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "../../../../components/IconButton";
import {faClose} from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
import styles from "./TrialCard.module.css";

const TrialCard = () => {
    const { subscription } = useAdmin()
    const { t } = useTranslation(['settings'])
    const [visible, setVisible] = useState<boolean>(true)

    return (subscription && subscription.type === 'trial' && subscription.valid && visible) ? (
        <Card classes={cx(styles['card'])}>
            <IconButton classes={cx(styles['closeButton'])} icon={faClose} color={'FC0'} onClick={() => setVisible(false)}/>
            <div className={cx(styles['info'])}>
                {t('subscription.info_card', {expire_date: subscription.expire_date})}
            </div>
        </Card>
    ) : null
}

export default TrialCard
